// extracted by mini-css-extract-plugin
export default {"even":"inventory_even__n77D7","odd":"inventory_odd__-JMRb"};